import HotelStars from './HotelStars';

export default HotelStars;
